import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore('reports-credit-processes', storeModule.createStoreModule('reports-credit-processes'))
